<template>
    <div id="room-wrapper">
        <div class="groups" v-if="roomData">

            <div class="group" v-bind:key="key" v-for="(group, key) in roomData.groups">
                <div class="box">
                    <h2 class="title">Grupp: {{key}}</h2>
                    <table class="table is-striped is-bordered is-fullwidth">
                        <thead>
                        <tr>
                            <th>Text</th>
                            <th>Media</th>
                            <th>Åldersgrupp</th>
                            <th>Verktyg</th>
                        </tr>
                        </thead>
                        <tbody>
                            <room-string v-for="(string,key) in group" v-bind:key="key" :orgdata="string" :index="key" :keyname="string.key || 'none'" :group="group" @stringDeleted="deleteMedia(...arguments)"></room-string>
                            <room-string :is_new="true" :group="key"></room-string>
                        </tbody>

                    </table>
                </div>
            </div>

            <room-help @stringUpdated="updateMedia(...arguments)" :orgdata="helpData"></room-help>

            <!-- <h3 class="title is-3">New row</h3>
            <room-string @stringUpdated="updateMedia(...arguments)" :is_new="true"></room-string>
            -->
        </div>
    </div>
</template>

<script>
import RoomData from '@/mixins/RoomMixin'

export default {
  name: 'GenericRoom',
  mixins: [RoomData],
  data () {
    return {
      data: {
        title: 'Test'
      }
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>
